import { render, staticRenderFns } from "./UserAssignmentGeneralReport.vue?vue&type=template&id=45ba66eb&scoped=true"
import script from "./UserAssignmentGeneralReport.vue?vue&type=script&lang=js"
export * from "./UserAssignmentGeneralReport.vue?vue&type=script&lang=js"
import style0 from "./UserAssignmentGeneralReport.vue?vue&type=style&index=0&id=45ba66eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ba66eb",
  null
  
)

export default component.exports